import axios from 'axios'

export default {
    listUniforms: async (params) => {
        const response = await axios.get('/uniforms', { params })

        return response && response.data && response.data.response
    },
}
